import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import BeforeAfter from '../components/BeforeAfter'
import Features from '../components/Features'
import Analytics from '../components/Analytics'
import HowItWorks from '../components/HowItWorks'
import Pricing from '../components/Pricing'
import Community from '../components/Community'
import FAQ from '../components/FAQ'
import CTA from '../components/CTA'
import Footer from '../components/Footer'
import SEOHead from '../components/SEOHead'

const Home = () => {
  return (
    <div className="min-h-screen">
      <SEOHead />
      <Navbar />
      <Hero />
      <HowItWorks />
      <Features />
      <Analytics />
      <CTA />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  )
}

export default Home
